import { TKV2_ORDER_ATTACHMENT_API } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetCompImagesError,
  GetCompImagesVariables,
  fetchGetCompImages,
} from '../toolkitComponents.ts';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.ts';

const API_SCHEMA = TKV2_ORDER_ATTACHMENT_API.COMP_IMAGES.GET;

export const useGetCompImages = (
  variables: GetCompImagesVariables,
  opts?: Omit<
    UseQueryOptions<z.infer<typeof API_SCHEMA.RESPONSE>, GetCompImagesError>,
    'queryKey' | 'queryFn'
  >,
): UseQueryResult<z.infer<typeof API_SCHEMA.RESPONSE>, GetCompImagesError> => {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<z.infer<typeof API_SCHEMA.RESPONSE>, GetCompImagesError>({
    queryKey: queryKeyFn({
      path: '/api/v2/compImages/{id}',
      operationId: 'getCompImages',
      variables,
    }),
    queryFn: async () => {
      const res = await fetchGetCompImages({ ...fetcherOptions, ...variables });
      return API_SCHEMA.RESPONSE.parse(res);
    },
    ...opts,
  });
};
